module.exports = __webpack_public_path__ + "img/360_icon.79e7428d.png";